var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48664 1.15984L11.2565 3.92972C12.0183 4.69154 11.8099 5.9758 10.8463 6.45766L8.05048 7.85552C7.94986 7.90586 7.87289 7.99362 7.83615 8.10004L7.01003 10.4913C6.83697 10.9923 6.19928 11.1391 5.82453 10.7644L4.04263 8.98247L1.49458 11.5306H0.885742L0.885788 10.9218L3.43384 8.37371L1.65193 6.5918C1.27719 6.21705 1.42408 5.57936 1.92499 5.4063L4.31634 4.58022C4.42272 4.54346 4.51048 4.46652 4.56081 4.36585L5.95867 1.57007C6.44053 0.606431 7.7248 0.39802 8.48664 1.15984ZM10.6477 4.53852L7.87782 1.76863C7.53154 1.42235 6.94775 1.51709 6.72878 1.9551L5.33091 4.75088C5.1799 5.05289 4.91662 5.28376 4.59746 5.39402L2.42292 6.14518L6.27114 9.99342L7.02237 7.8189C7.13263 7.49971 7.36348 7.23649 7.66545 7.08547L10.4612 5.68755C10.8992 5.46858 10.994 4.8848 10.6477 4.53852Z",
    fill: "#051123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6477 4.53852L7.87782 1.76863C7.53154 1.42235 6.94775 1.51709 6.72878 1.9551L5.33091 4.75088C5.1799 5.05289 4.91662 5.28376 4.59746 5.39402L2.42292 6.14518L6.27114 9.99342L7.02237 7.8189C7.13263 7.49971 7.36348 7.23649 7.66545 7.08547L10.4612 5.68755C10.8992 5.46858 10.994 4.8848 10.6477 4.53852Z",
    fill: "#051123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLargeIcon);
export default __webpack_public_path__ + "static/media/pin_large_icon.7b8db289d0ee2939eb42de9afa60b0d8.svg";
export { ForwardRef as ReactComponent };